import React from 'react';
import { Box, } from '@waglabs/box-next';
export const LazyWrapper = (props) => (React.createElement(Box, Object.assign({ pb: "100%", position: "relative", width: "100%" }, props)));
